/**
 * Account stats thunks (legacy insyt-api).
 *
 * Backed by `GET /api/v1/stats/summary`, which returns account-wide figures for
 * the signed-in caller:
 *   { active_forms, total_responses, date_range: { start_date, end_date } }
 *
 * `active_forms` is a live total and is NEVER filtered by the date range — only
 * `total_responses` is. The legacy insyt-api returns HTTP 200 with a `statusCode`
 * in the body on success, and REAL HTTP status codes on error (400 bad date, 404,
 * 500…), so success lands in `.then` and failures in `.catch`.
 */
import { get } from '../../utils/api';
import {
  FETCHING_STATS_SUMMARY,
  FETCHING_STATS_SUMMARY_SUCCESS,
  FETCHING_STATS_SUMMARY_FAILED,
} from '../../utils/types';

// startDate/endDate are 'YYYY-MM-DD' strings, or undefined for an open-ended
// (all-time) bound. Both apply to total_responses only.
export const fetchStatsSummary = (startDate, endDate) => {
  return dispatch => {
    dispatch({ type: FETCHING_STATS_SUMMARY });

    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return get('/stats/summary', { params })
      .then(response => {
        if (response.data && response.data.statusCode === 200) {
          dispatch({
            type: FETCHING_STATS_SUMMARY_SUCCESS,
            data: response.data.data,
          });
          return response.data.data;
        }
        dispatch({ type: FETCHING_STATS_SUMMARY_FAILED });
      })
      .catch(error => {
        dispatch({ type: FETCHING_STATS_SUMMARY_FAILED, error });
      });
  };
};
